import {mapGetters} from 'vuex';
import videoProvider from '@/components/video-providers/index.vue'

export default {
    name: 'video-trailer',
    components: {
        videoProvider
    },
    computed: {
        ...mapGetters({
            popupTrailer: 'popups/popupTrailer',
        }),

        videoInfo() {
            return {
                provider: this.popupTrailer.provider,
                src: this.popupTrailer.url,
                chapters: {
                    data: []
                }
            }
        },

        replaceUrl() {
            switch (this.popupTrailer.provider) {
                case 'youtube': {
                    const regex = /^.*(youtu.be\/|v\/|e\/|u\/\w+\/|embed\/|v=)([^#\&\?]*).*/;
                    const id = this.popupTrailer.url.match(regex)[2];
                    return `https://www.youtube.com/embed/${id}`
                }
                default: {
                    const regex = /(videos|video|channels|\.com)\/([\d]+)/;
                    const id = this.popupTrailer.url.match(regex)[2];
                    return `https://player.vimeo.com/video/${id}`
                }
            }
        }
    }
}
